// extracted by mini-css-extract-plugin
export default {"dot":"Related_dot__HU0I-"};